import { PartnerResource, partnerResource } from '@witkac/kartamiejska-resources';
import { DisplayState, EntityModuleState, Partner, PartnerRegister } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';
import benefits from './partner/benefits.module';
import places from './partner/places.module';

/**
 * Moduł partnerów
 *
 * @export
 * @class PartnersModule
 * @extends {EntityModule<Partner, PartnerResource>}
 */
export class PartnersModule extends EntityModule<Partner, PartnerResource> {
  /**
   * Submoduły
   * usługi, historia
   *
   * @memberof PartnersModule
   */
  public modules = { benefits, places };

  constructor() {
    super(partnerResource);

    this.mutations = {
      ...this.mutations,
      /**
       * Dodaje partnera do listy
       *
       * @param localState stan lokalny
       * @param data dane do wysłania do API
       */
      add(localState: EntityModuleState<Partner>, data: any): void {
        data.state = DisplayState.NOT_CONFIRMED;
        data.benefitsCount = 0;
        localState.list.unshift(data);
      }
    };

    this.actions = {
      ...this.actions,
      /**
       * Dodanie partnera
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: PartnerRegister): Promise<void> => {
        data.partner.id = await this.resource.add(data);
        context.commit('add', data.partner);
        context.commit('incrementCount');
      },

      /**
       * Przełączanie ukrycia/pokazania
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<void>}
       */
      toggleHidden: async (context: any, id: number): Promise<void> => {
        await this.resource.toggleHidden(id);
        return context.dispatch('get', id);
      },

      /**
       * Przypisanie wielu usług do partnera
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<void>}
       */
      assign: async (context: any, data: any): Promise<void> => {
        await this.resource.assignBenefits(data.id, data.ids);
      }
    };
  }
}

export default new PartnersModule();
